import dataProvider from '@/api'

export default {
  /**
   * @description Применение промокода
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.17#/%D0%9F%D1%80%D0%BE%D0%BC%D0%BE%D0%BA%D0%BE%D0%B4%D1%8B/OrdersApplyPromocode
   *
   * @param {object} payload
   * @param {object} payload.orderId_H - required
   * @param {object} payload.promocode - required
   *
   * @returns {object}
   */
  postOrdersPromocodeApply (payload = {}) {
    return dataProvider.post('/orders/promocode/apply', payload)
  },
}
